// extracted by mini-css-extract-plugin
export default {"ListeReglements":"AffichageReglements_ListeReglements__k+Y-D","LigneReglement":"AffichageReglements_LigneReglement__QtRB+","BoutonAnnuler":"AffichageReglements_BoutonAnnuler__srrpr"};